export const Loading = () => {
    return (
      <div className="loading-map">
        <div className="text-center">
          <h3>Espere por favor</h3>
          <span>Localizando...</span>
        </div>
      </div>
    );
}